// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"af2f473f","396":"e0240847","421":"25b1d5ea","655":"493e975e","788":"c29bf96e","981":"68f38ef6"}[chunkId] + ".chunk.css";
};